import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../utils/appConstants.class';

import { v4 as uuid } from 'uuid';

@Injectable({ providedIn: 'root' })
export class HeaderInterceptor implements HttpInterceptor {
  constructor() {}

  public get applicationType(): number {
    const type = sessionStorage.getItem(AppConstants.CURRENT_APP_TYPE);
    if (type) {
      return +type;
    }
    return null;
  }

  get sessionId(): string {
    let sessionId = sessionStorage.getItem(AppConstants.SESSION_ID);
    if (sessionId) {
      return sessionId;
    }
    sessionId = uuid();
    sessionStorage.setItem(AppConstants.SESSION_ID, sessionId);
    return sessionId;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('ignore')) {
      return next.handle(req);
    }
    let headers = req.headers
      .set('Content-Type', 'application/json')
      .set('Accept', 'q=0.8;application/json;q=0.9')
      .set('SessionId', this.sessionId);

    if (this.applicationType) {
      headers = headers.set('ApplicationType', String(this.applicationType));
    }
    const request = req.clone({ headers });
    return next.handle(request);
  }
}
